"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EnumNotificationType;

(function (EnumNotificationType) {
  EnumNotificationType["ITEM_REVIEWED"] = "ITEM_REVIEWED";
  EnumNotificationType["GROUP_NEW_PENDING"] = "GROUP_NEW_PENDING";
  EnumNotificationType["GROUP_NEW_APPROVED"] = "GROUP_NEW_APPROVED";
  EnumNotificationType["ITEM_DELETED"] = "ITEM_DELETED";
})(EnumNotificationType = exports.EnumNotificationType || (exports.EnumNotificationType = {}));

var EnumNotificationItemReviewResult;

(function (EnumNotificationItemReviewResult) {
  EnumNotificationItemReviewResult["NA"] = "NA";
  EnumNotificationItemReviewResult["PENDING"] = "PENDING";
  EnumNotificationItemReviewResult["APPROVED"] = "APPROVED";
  EnumNotificationItemReviewResult["REJECTED"] = "REJECTED";
})(EnumNotificationItemReviewResult = exports.EnumNotificationItemReviewResult || (exports.EnumNotificationItemReviewResult = {}));

var EnumPlatform;

(function (EnumPlatform) {
  EnumPlatform[EnumPlatform["NA"] = 0] = "NA";
  EnumPlatform[EnumPlatform["WEB"] = 1] = "WEB";
  EnumPlatform[EnumPlatform["APP"] = 2] = "APP";
})(EnumPlatform = exports.EnumPlatform || (exports.EnumPlatform = {}));